import server from '@/utils/request'

/**
 * Get captcha configuration
 * @returns 
 */
export const config = () => server.get(`/authorize/captcha/config`)

/**
 * Get captcha image
 * @returns 
 */
export const code = () => server.get<{ base64: string, key: string }>(`/authorize/captcha/image?width=130&height=30`)

/**
 * Login
 * @returns 
 */
export const authLogin = (data: any) => server.post(`/app/user/login`, data)

/**
 * Query initialization configuration
 * @returns 
 */
export const getInitSet = () => server.get(`/user/settings/init`)

/**
 * Create initialization configuration
 * @returns 
 */
export const postInitSet = (data: any) => server.post(`/user/settings/init`, data)

/**
 * Query system version information
 * @returns 
 */
export const systemVersion = () => server.get(`/system/version`)

/**
 * Get supported SSO applications
 * @returns 
 */
export const bindInfo = () => server.get(`/application/sso/_all`)

/**
 * Query configuration information
 * @returns 
 */
export const settingDetail = (scopes: string) => server.get(`/system/config/${scopes}`)

/**
 * Get current logged-in user information
 */
export const userDetail = () => server.get<any>('/user/detail')

/**
 * Logout
 */
export const loginout_api = () => server.get<any>('/user-token/reset')

export const getOAuth2 = (params: any) => server.get<any>('/oauth2/authorize', params)

export const initApplication = (clientId: string | number) => server.get<{name: string}>(`/application/${clientId}/info`)


// Get server time

export const getromoteTime = () => server.get<any>('/app/user/timestamp')
